import React from 'react';
import { Classes, PopoverInteractionKind } from '@blueprintjs/core';
import { Box, Icon, Popover, Text } from 'core/components';
import { FiInfo } from 'react-icons/fi';

export default ({ content, errors, isAggregated = false }) => {
  if (!content && (!errors || errors.length === 0)) {
    return '---';
  }

  return (
    <Popover
      minimal={false}
      interactionKind={PopoverInteractionKind.HOVER}
      content={
        <Box p={2} maxWidth={500} className={Classes.TEXT_SMALL}>
          {content ||
            errors.map(({ code, message }) => (
              <Text key={code} as="div">
                {message}
              </Text>
            ))}
        </Box>
      }
    >
      <Icon style={{ cursor: 'pointer' }} iconSize={14} icon={FiInfo} color={isAggregated ? 'muted' : 'danger'} />
    </Popover>
  );
};
